var version = {
    "name":      "dativery",
    "buildDateCode": "20260429-095817",
    "buildDate": "Wed Apr 29 2026 09:58:17 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260429-095817",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;